import platform from 'components/Trackers/platform'

export const ScreenViewedEvent = {
  feature: 'MOC Registration Funnel',
  event_description: 'Interstitial Screen Viewed',
  platform,
  object: 'Screen',
  action: 'Viewed',
  object_name: 'mocRegistrationFunnelInterstitial',
  screen: 'mocRegistrationFunnelInterstitial',
  screen_name: 'mocRegistrationFunnelInterstitial',
}

export const NextButtonTappedEvent = {
  feature: 'MOC Registration Funnel',
  event_description: 'Interstitial Next button tapped',
  platform,
  object: 'Button',
  action: 'Tapped',
  object_name: 'mocRegistrationFunnelInterstitialNext',
  screen: 'mocRegistrationFunnelInterstitial',
  screen_name: 'mocRegistrationFunnelInterstitial',
}

export const MoreInfoButtonTappedEvent = {
  feature: 'MOC Registration Funnel',
  event_description: 'Direct Deposit More Info button tapped',
  platform,
  object: 'Button',
  action: 'Tapped',
  object_name: 'mocRegistrationFunnelInterstitialMoreInfo',
  screen: 'mocRegistrationFunnelInterstitial',
  screen_name: 'mocRegistrationFunnelInterstitial',
}

export const MoreInfoContainerViewedEvent = {
  feature: 'MOC Registration Funnel',
  event_description: 'Direct Deposit More Info Modal container viewed',
  platform,
  object: 'Container',
  action: 'Viewed',
  object_name: 'registrationMOCPricingModal',
  screen: 'mocRegistrationFunnelInterstitialPricingModal',
  screen_name: 'mocRegistrationFunnelInterstitialPricingModal',
}

export const MoreInfoOkButtonTappedEvent = {
  feature: 'MOC Registration Funnel',
  event_description: 'Direct Deposit More Info Ok button tapped',
  platform,
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationMOCPricingModalOk',
  screen: 'mocRegistrationFunnelInterstitialPricingModal',
  screen_name: 'mocRegistrationFunnelInterstitialPricingModal',
}

export const SkipButtonTappedEvent = {
  feature: 'MOC Registration Funnel',
  event_description: 'Interstitial Skip Button tapped',
  platform,
  object: 'Button',
  action: 'Tapped',
  object_name: 'mocRegistrationFunnelInterstitialSkip',
  screen: 'Registration: MOC Interstitial',
  screen_name: 'Registration: MOC Interstitial',
}

export const IntentScreenViewedEvent = {
  feature: 'Registration MOC Intent',
  event_description: 'Screen Viewed',
  platform,
  object: 'Screen',
  action: 'Viewed',
  object_name: 'registrationMocIntent',
  screen: 'registrationMocIntent',
  screen_name: 'registrationMocIntent',
}

export const IntentOptOutEvent = (cta: string) => ({
  feature: 'Registration MOC Intent',
  event_description: 'Dismiss Button Tapped',
  platform,
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationMocIntentDismiss',
  screen: 'registrationMocIntent',
  screen_name: 'registrationMocIntent',
  cta_title: cta,
})

export const IntentOptInEvent = (cta: string) => ({
  feature: 'Registration MOC Intent',
  event_description: 'Opt In Button Tapped',
  platform,
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationMocIntentRemindMeLater',
  screen: 'registrationMocIntent',
  screen_name: 'registrationMocIntent',
  cta_title: cta,
})
